import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { codes as methodCodes } from 'constants/payment';
import Currency from 'utils/Currency';

import { CashInput } from 'components/ui/Inputs';
import ValidationForm from 'components/ui/ValidationForm';

import { generate } from 'short-uuid';
import SplitPayment from '../../SplitPayment';
import { handlePaymentSubmit } from '../../SplitPayment/SplitPayment.utils';
import { Errors } from '../../SplitPayment/SplitPayment.styles';

const CashPayment = ({
  loading,
  isOnHold,
  totalPriceToBePaid,
  currentAmount,
  onAmountChange,
  payAndConfirm,
  takeDeposit,
  addPayment,
  bookingReference,
  currency,
  isPutOnHoldWithDeposit
}) => (
  <ValidationForm
    fields={{ amount: currentAmount }}
    validators={{
      amount: (values) => Number(values.amount) !== 0
    }}
    overrideFields={{ amount: currentAmount }}
    validateInitialFields
  >
    {({ fields: { amount: cashTendered }, onChange, invalidInputs, hasInvalidInputs }) => {
      const handleChange = (event) => {
        onChange(event);

        if (onAmountChange) {
          onAmountChange(event.target.value);
        }
      };

      const changeDue = Currency.subtract(cashTendered, totalPriceToBePaid);

      return (
        <SplitPayment
          isCashPayment={true}
          totalPriceToBePaid={totalPriceToBePaid}
          changeDue={changeDue}
          currency={currency}
          title={<FormattedMessage id="payments.AmountToPayByCash" />}
          subTitle={<FormattedMessage id="payments.canBeSplit" />}
          label={<FormattedMessage id="payments.recordPayment" />}
          loading={loading}
          onSubmit={(e) => {
            e.preventDefault();

            handlePaymentSubmit({
              cashTendered,
              totalPriceToBePaid,
              payAndConfirm,
              takeDeposit,
              addPayment,
              isOnHold,
              bookingReference,
              reference: generate(),
              currency,
              method: methodCodes.CASH
            });
          }}
          disabled={hasInvalidInputs}
        >
          <CashInput
            isCashPayment={true}
            name="amount"
            value={cashTendered}
            placeHolder={0}
            currency={currency}
            disabled={isPutOnHoldWithDeposit ? false : isOnHold}
            onChange={handleChange}
            changeDue={changeDue}
          />
          <Errors>{invalidInputs.amount && <FormattedMessage id="payments.amountZero" />}</Errors>
        </SplitPayment>
      );
    }}
  </ValidationForm>
);

CashPayment.propTypes = {
  bookingReference: PropTypes.string,
  isOnHold: PropTypes.bool,
  totalPriceToBePaid: PropTypes.number,
  currentAmount: PropTypes.string,
  onAmountChange: PropTypes.func,
  loading: PropTypes.bool,
  payAndConfirm: PropTypes.func,
  takeDeposit: PropTypes.func,
  addPayment: PropTypes.func,
  currency: PropTypes.string,
  isPutOnHoldWithDeposit: PropTypes.bool
};

export default CashPayment;
